import { ReactComponent as HeadlinerLogo } from 'assets/icons/headliner-logo.svg';

export default HeadlinerLogo;
